// extracted by mini-css-extract-plugin
export var editInput = "_es-0";
export var editInputCompact = "_es-2";
export var editInputLarge = "_es-1";
export var editInputSmall = "_es-3";